<template>
    <div class="row p-2">
        <div class="col-12">
            <div class="row">
                <div class="col-12">
                    <h2>{{ $t("transportations.detail") }} - {{ transportation.id }}</h2>
                </div>
                <div>
                    <router-link :to="'/transportation/' + transportation.id + '/edit'" v-if="isOwnerOrDispecher()" class="btn btn-primary text-white me-2">
                        <span>{{ $t("utils.edit") }}</span>
                    </router-link>
                    <button v-if="isOwnerOrDispecher()" @click="deleteTransportation" class="btn btn-primary text-white">
                        <span>{{ $t("utils.delete") }}</span>
                    </button>
                </div>

                <div class="col-12 col-md-6 mt-5">
                    <dl class="row">
                        <!-- Date -->
                        <dt class="col-sm-3">{{ $t("transportations.date") }}:</dt>
                        <dd class="col-sm-9">{{ transportation.date }}</dd>

                        <!-- Type of -->
                        <dt v-if="transportation.load_type" class="col-sm-3">{{ $t("transportations.transportType") }}:</dt>
                        <dd v-if="transportation.load_type" class="col-sm-9">{{ transportation.load_type.name }}</dd>

                        <dt v-if="transportation.load_type && transportation.load_type.choice" class="col-sm-3">{{ $t("transportations.choice") }}:</dt>
                        <dd v-if="transportation.load_type && transportation.load_type.choice" class="col-sm-9">{{ transportation.load_type.choice }}</dd>

                        <!-- Driver -->
                        <dt class="col-sm-3">{{ $t("transportations.driver") }}:</dt>
                        <dd class="col-sm-9">{{ transportation.driver ? transportation.driver.name : "-" }}</dd>

                        <!-- CMR OR WAGON -->
                        <dt class="col-sm-3">{{ $t("transportations.cmrOrWagon") }}:</dt>
                        <dd class="col-sm-9">
                            <div v-if="transportation.cmr_wagon_number && transportation.cmr_wagon_number.length > 0"
                                v-for="c in transportation.cmr_wagon_number" :key="c.id">
                                {{ $t("transportations.cmrWagonShort") }}: {{ c.cmr_or_wagon_number }}, {{ $t("transportations.amount") }}: {{ c.amount }}
                            </div>
                            <span v-else>-</span>
                        </dd>

                        <!-- License plate -->
                        <dt class="col-sm-3">{{ $t("transportations.spz") }}:</dt>
                        <dd class="col-sm-9">{{ transportation.license_plate ? transportation.license_plate.name : "-" }}</dd>

                        <!-- Place of loading -->
                        <dt class="col-sm-3">{{ $t("transportations.placeOfLoading") }}:</dt>
                        <dd class="col-sm-9">
                            <div v-if="transportation.load_location && transportation.load_location.length > 0"
                                v-for="c in transportation.load_location" :key="c.id">{{ c.name }}</div>
                            <span v-else>-</span>
                        </dd>

                        <!-- Place of delivery -->
                        <dt class="col-sm-3">{{ $t("transportations.placeOfDelivery") }}:</dt>
                        <dd class="col-sm-9">
                            <div v-if="transportation.unload_location && transportation.unload_location.length > 0"
                                v-for="c in transportation.unload_location" :key="c.id">{{ c.name }}</div>
                            <span v-else>-</span>
                        </dd>

                        <!-- Recipient -->
                        <dt class="col-sm-3">{{ $t("transportations.recipient") }}:</dt>
                        <dd class="col-sm-9">{{ transportation.recipient ? transportation.recipient.name : "-" }}</dd>

                        <!-- Subscriber -->
                        <dt class="col-sm-3">{{ $t("transportations.subscriber") }}:</dt>
                        <dd class="col-sm-9">{{ transportation.subscriber ? transportation.subscriber.name : "-" }}</dd>

                        <!-- Sortiment -->
                        <dt class="col-sm-3">{{ $t("transportations.sortiment") }}:</dt>
                        <dd class="col-sm-9">{{ transportation.wood_type ? transportation.wood_type.name : "-" }}</dd>
                    </dl>
                </div>
            </div>

            <div class="col-12 mt-3">
                <FilesContainer :files="transportation.files" :transportFileContainer="true" @uploadFile="uploadFile"
                    @deleteFile="deleteFile" @downloadFile="downloadFile" />
            </div>
        </div>
    </div>
</template>
<script>
import FilesContainer from "@/components/FilesContainer.vue";

export default {
    components: {
        FilesContainer
    },
    data() {
        return {
            transportation: {},
            transportationId: this.$route.params.id
        }
    },
    created() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.$store.getters.api.get("/transportation/" + this.transportationId).then((response) => {
                this.transportation = response.data.item;
            });
        },

        uploadFile: function (data) {
            const formData = new FormData();
            formData.append("title", data.title);
            formData.append("file_type", data.file_type);
            formData.append("file", data.file);

            this.$store.getters.api.post("/transportation/" + this.transportationId + "/files/add", formData).then((response) => {
                this.loadData();
            })
        },
        deleteFile: function (id) {
            this.$store.getters.api.delete("/transportation/" + this.transportationId + "/files/" + id + "/delete").then((response) => {
                this.loadData();
            })
        },
        downloadFile: function (documentItem) {
            const fileName = documentItem.name || 'downloaded_document';

            this.$store.getters.api.get(`/transportation/${this.transportationId}/files/${documentItem.id}/download`, {
                responseType: 'blob'
            }).then((response) => {
                if (response.data) {
                    const documentItem = response.data;

                    // Create a Blob URL using the provided Blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));

                    // Create a link element to trigger the download
                    const link = window.document.createElement('a');

                    const fileExtension = documentItem.type.split('/')[1];  // Extract extension (e.g., 'pdf' from 'application/pdf')
                    link.href = url;

                    // Use the Blob type to determine the filename with extension
                    link.setAttribute('download', `${fileName}.${fileExtension}`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();

                    this.loadData();
                }
            }).catch(error => {
                console.error("Document download failed:", error);
            });
        },
        deleteTransportation: function () {
            this.$store.getters.api.delete("/transportation/" + this.transportationId + "/delete").then((response) => {
                this.$router.push({ name: "Transportations" });
            })
        },
        isOwnerOrDispecher: function () {
            var isOwnerOrDispecher = false;
            this.$store.state.user.functions.forEach(element => {
                if (element.name == "owner") {
                    isOwnerOrDispecher = true;
                }
                else if (element.name == "dispatcher") {
                    isOwnerOrDispecher = true;
                }
            })
            return isOwnerOrDispecher;
        },
    },
}
</script>
<style lang="">

</style>